'use strict';

angular.module('adminDefaultEntitlementRoutes', ['adminDefaultEntitlementControllers',
                                                 'services.authenticatedUser'])

.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('adminDefaultEntitlement', {
            url: '/Administration/DefaultEntitlement',
            templateUrl: require('./MainDefaultEntitlement.tpl.html'),
            controller: 'MainDefaultEntitlementController',
            resolve: {
                authenticatedUser: [
                    'authenticatedUserService', function(service) {
                        return service.getAuthenticatedUser();
                    }
                ]
            }
        })
        .state('adminDefaultEntitlement.bySystemRole', {
            url: '/{systemId:int}',
            views: {
                'BySystemRole@adminDefaultEntitlement': {
                    templateUrl: require('./BySystemRole.tpl.html'),
                    controller: 'BySystemRoleController',
                } 
            }
        })
        .state('adminDefaultEntitlement.bySystemRole.viewExistingRights', {
            url: '/{systemRoleId:int}',
            views: {
                'Feature@adminDefaultEntitlement': {
                    templateUrl: require('./ViewExistingRights.tpl.html'),
                    controller: 'ViewExistingRightsController',
                } 
            }
        })
        .state('adminDefaultEntitlement.bySystemRole.addDefaultEntitlement', {
            url: '/{systemRoleId:int}',
            views: {
                'Feature@adminDefaultEntitlement': {
                    templateUrl: require('./AddDefaultEntitlement.tpl.html'),
                    controller: 'AddDefaultEntitlementController',
                } 
            }
        })
        .state('adminDefaultEntitlement.bySystemRole.viewExistingRights.bySupervisor', {
            url: '/{supervisorId:int}',
            views: {
                'FeatureDetails@adminDefaultEntitlement': {
                    templateUrl: require('./ViewSupervisorDetails.tpl.html'),
                    controller: 'ViewSupervisorDetailsController',
                    resolve: {
                        impactedEmployees: [
                            '$stateParams', 'adminDefaultEntitlementService', function ($stateParams, adminDefaultEntitlementService) {
                                return adminDefaultEntitlementService.getDefaultEntitlements($stateParams.systemRoleId, $stateParams.supervisorId);
                            }
                        ]
                    }
                }
            }
        });
}]);